import { AlignmentType, BorderStyle, Document, Footer, Header, HeadingLevel, ImageRun, LevelFormat, NumberFormat, Packer, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, TabStopType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TextRun, VerticalAlign, WidthType, convertInchesToTwip } from 'docx'
import { certinDesign, fontPageBlueImage, reportAppName, reportAppDate } from './Part1/FrontPage'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'
import { url } from '../../../../../../src/constants/url'
// import homepageImage from '../../../../Assests/ReportImages/isecurion1.png';
import homepageImage from '../../../../../Assests/ReportImages/isecurion1.png'
import { documentFirstTable, documentHeading, documentHeading2, documentSecondTable } from '../CertIn/Part1/Page1-Support'
import { page2Heading, page2Heading2, page2firstTable, page2secondTable } from '../CertIn/Part1/Page2-Support.js'
import { TOCHeadings } from '../CertIn/Part1/Page3-Support.js'
import { aboutPage1, aboutPage2, aboutPage3, aboutPage4, bulletOne, bulletTwo, bulletThree, bulletfour, bulletfive, bulletsix } from '../CertIn/Part1/Page4-Support.js'
import { disclaimerHeading, disclaimerPage1, disclaimerPage2, disclaimerPage3, disclaimerPage4, disclaimerPage5 } from '../CertIn/Part1/Page5-Support.js'
import { objectiveBulletOne, objectiveBulletThree, objectiveBulletTwo, objectiveHeading, objectivePage1, overviewHeading, scope1, scopeHeading, scopeTable, overviewPage1 } from '../CertIn/Part1/Page6-Support.js'
import { noteUserRoles, recommendationBulletOne, recommendationBulletTwo, sumaryNote1, summaryBulletOne, summaryHeading, SummaryNote, SummaryRecommendation, summeryPage } from '../CertIn/Part2/Page7-Support.js'
import { methodologyHeading, setUpAndMethodology, accrualPhase, accrualPhaseText, accrualPhasebullet1, accrualPhasebullet2, accrualPhasebullet3, acclimatizePhase, acclimatizePhaseText } from '../CertIn/Part2/Page8-Support.js'
import { analysisPhase, analysisPhaseText, admittancePhase, admittancePhaseText, affirmationPhase, affirmationPhaseText } from '../CertIn/Part2/Page9-Support.js'
import { frameworkHeading, framework, frameworkText, tools, toolsTable, areaCovered, areaCoveredText, coveredPoint1, coveredPoint2, coveredPoint3, coveredPoint4, coveredPoint5, coveredPoint6, coveredPoint7 } from './Part2/Page10-Support.js'
import { barchartText, OWASPHeading, owasptableText, OWASPText1, OWASPText2, top10ListTable } from './Part2/Page11-Support.js'
import { observationHeading, observationText1, observationText2, mappingTable } from '../CertIn/Part2/Page13-Support.js'
import { severityText, severityTable, exploitationTable } from '../CertIn/Part2/Page14-Support.js'
import { graphText, severityLevelTable, tableText, piechartText } from '../CertIn/Part3/Page15-Support.js'
import { findingsText1, findingsTable } from '../CertIn/Part3/Page16-Support.js'
import { stageText1, stageText2, stageText3 } from '../CertIn/Part3/Page17-Support.js'
import { verificationTable } from '../CertIn/Part3/Page19-Support.js'
import { conclusionText1, conclusionText2, conclusionText3, conclusionText4, conclusionText5, conclusionText6, conclusionText7, conclusionText8, conclusionText9, conclusionText10, conclusionText11 } from '../CertIn/Part3/EndPage-Support.js'
import { confidentialMaterial1Certin, confidentialMaterial2Certin, confidentialMaterial3Certin, confidentialMaterial4Certin } from '../../../../Reports/Web/CertInSupport-Page/Part1CertIn/confidential.js'

export async function WebCERTInReportSkeleton(props) {
    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl, appDiscription
    } = props



    const reportName = `${applicationName} Security Audit Phase 1 Report of Web Application`

    const frontPage1 = certinDesign
    const frontPage2 = fontPageBlueImage
    const frontPage3 = reportAppName(applicationName)
    const FrontPage4 = reportAppDate(date)

    const page11c = confidentialMaterial1Certin
    const page12c = confidentialMaterial2Certin
    const page13c = confidentialMaterial3Certin(customerName)
    const page14c = confidentialMaterial4Certin(customerName)


    const page11 = documentHeading
    const page12 = documentFirstTable(applicationName)
    const page13 = documentHeading2
    const page14 = documentSecondTable(customerName, date)

    const page21 = page2Heading
    const page22 = page2firstTable(date)
    const page23 = page2Heading2
    const page24 = page2secondTable

    // page 3 details
    const page31 = TOCHeadings

    // page 4 Details

    // const page41 = aboutHeading
    const page42 = aboutPage1
    const page43 = aboutPage2
    const page44 = aboutPage3
    const page45 = aboutPage4
    const page46 = bulletOne
    const page47 = bulletTwo
    const page48 = bulletThree
    const page49 = bulletfour
    const page50 = bulletfive
    const page51 = bulletsix

    // page 5 details
    // const page501 = disclaimerHeading
    const page52 = disclaimerPage1(customerName)
    const page53 = disclaimerPage2
    const page54 = disclaimerPage3(customerName)
    const page55 = disclaimerPage4
    const page56 = disclaimerPage5

    // page 6 Details
    // const page61 = overviewHeading
    const page62 = overviewPage1(appDiscription)
    // const page63 = objectiveHeading
    const page64 = objectivePage1(applicationName)
    const page65 = objectiveBulletOne(applicationName)
    const page66 = objectiveBulletTwo
    const page67 = objectiveBulletThree
    const page68 = scopeHeading
    const page69 = scope1(applicationName)
    const page70 = scopeTable(applicationName, applicationURL)


    // page 7 details
    // const page71 = summaryHeading
    const page72 = summeryPage(customerName, applicationName)
    const page73 = summaryBulletOne(testEndDate, testStartDate)
    const page74 = SummaryNote
    // const page75 = sumaryNote1(environmentType, testingType) /* this  is doubt*/
    const page76 = noteUserRoles(testingType !== "Black box testing methodology (Unauthenticated Testing)" ? userRoles : '')
    const pagee77 = SummaryRecommendation
    const page78 = recommendationBulletOne
    const page79 = recommendationBulletTwo

    // page 8 Details
    const page81 = methodologyHeading
    const page82 = setUpAndMethodology
    const page83 = accrualPhase
    const page84 = accrualPhaseText
    const page85 = accrualPhasebullet1
    const page86 = accrualPhasebullet2
    const page87 = accrualPhasebullet3
    const page88 = acclimatizePhase
    const page89 = acclimatizePhaseText

    // page 9 details
    const page91 = analysisPhase
    const page92 = analysisPhaseText
    const page93 = admittancePhase
    const page94 = admittancePhaseText
    const page95 = affirmationPhase
    const page96 = affirmationPhaseText

    // page 10 details
    // const page101 = frameworkHeading
    const page102 = framework
    const page103 = frameworkText(applicationName, customerName)
    const page104 = tools
    const page105 = toolsTable
    const page106 = areaCovered
    const page107 = areaCoveredText
    const page108 = coveredPoint1
    const page109 = coveredPoint2
    const page110 = coveredPoint3
    const page1011 = coveredPoint4
    const page1012 = coveredPoint5
    const page1013 = coveredPoint6
    const page1014 = coveredPoint7

    // page 11 details
    // const page111 = OWASPHeading
    const page112 = barchartText
    const page113 = OWASPText1
    const page114 = OWASPText2

    // page 12 detaails
    const page121 = owasptableText
    const page122 = top10ListTable(brokenAccess, cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures, securityFailures, ssrf)

    // // page 13 Details
    // const page131 = observationHeading
    const page132 = observationText1(applicationName, vulCount)
    const page133 = observationText2
    const page134 = mappingTable

    // page 14 details
    const page141 = severityText
    const page142 = severityTable
    const page143 = exploitationTable

    // page 15 details
    const page151 = graphText
    const page152 = severityLevelTable(critical, high, medium, low, info)
    const page153 = tableText
    const page154 = piechartText

    // page 16 details
    const page162 = findingsText1
    const page163 = findingsTable

    //    page 17 details
    const page172 = stageText1
    const page173 = stageText2
    const page174 = stageText3

    //  page 19 details
    const page191 = verificationTable

    // Ending page Details
    const page201 = conclusionText1(applicationName)
    const page202 = conclusionText2
    const page203 = conclusionText3
    const page204 = conclusionText4
    const page205 = conclusionText5
    const page206 = conclusionText6
    const page207 = conclusionText7
    const page208 = conclusionText8
    const page209 = conclusionText9
    const page210 = conclusionText10
    const page211 = conclusionText11(date)


    const AboutHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "About ISECURION",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const DisclaimerHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Disclaimer",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const ApploicationOveriew = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Application Overview",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Objectives = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Objectives and Scope",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const page131 = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Observation Summary",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const cvssMapping = new Paragraph({
        spacing: { before: 350, after: 500 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 1 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "CVSS 3.1 MAPPING",
                size: 26,
                color: "c00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const easeOfExploitation = new Paragraph({
        spacing: { before: 350, after: 500 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 1 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Ease of Exploitation",
                size: 26,
                color: "c00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const Executive = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Executive Summary",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Methodology = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methodology",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const Frameworkandtools = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Framework and tools used for Audit",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const BenchmarkingwithOWASP1 = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Benchmarking with OWASP TOP 10",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    const ObservationSummary = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Observation Summary",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    //overview of heading
    const page161 = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Overview of Findings",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    //Detailed Stage 1 Findings and Recommendations
    const page171 = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Detailed Stage 1 Findings and Recommendations",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    //Methods of verification to compliance with CERT-In Directions
    const MethodsHeading = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methods of verification to compliance with CERT-In Directions",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })
    //Conclusion
    const Conclusion = new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 150, after: 250, },
        indent: { left: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Conclusion",
                size: 26,
                color: "C00000",
                font: "Cambria",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })


    const design = {
        page: {
            margin: { header: 350, footer: 700 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }

    const imageData = await fetch(homepageImage).then(response => response.blob());
    const footerIsecurion = new ImageRun({
        type: 'png',
        data: await imageData.arrayBuffer(),
        transformation: {
            width: 225,
            height: 60
        },
    });

    const MAX_WIDTH = 670;
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            return new ImageRun({
                data: imageData,
                transformation: { width: 624, height: 300 },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 6, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            indent: { left: 30, right: 30 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 27, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Name of Vulnerability",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 13, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 54, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 100, after: 100 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Recommendations",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                })
            ],
        }),
    ];
    const sortVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);

    sortVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
            } else {
                severity = "Info";
            }
            return { severity };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity } = getSeverityAndColor(riskScore);

        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                indent: { left: 60 },
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),

                    new TableCell({
                        width: { size: 53, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    indent: { left: 500, right: 50 },
                                    spacing: { before: 50, after: 50 },
                                    bullet: { level: 0 },
                                    alignment: AlignmentType.LEFT,
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            )

                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })

                ],
            })
        );
    });

    // Vulnerability Table
    const sortedVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            combinedContent.push(
                new Paragraph({
                    children: [
                        new TextRun({
                            text: `${pocText}`,
                            size: 24,
                        }),
                    ],
                })
            );

            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }


        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({
                pageBreakBefore: true,
                heading: HeadingLevel.HEADING_1,
                spacing: { before: 150, after: 200 },
                indent: { left: 600 },
                width: { size: 100, type: WidthType.PERCENTAGE },
                numbering: { reference: "my-crazy-numbering", level: 2 },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false
                    })
                ],
            }),
            new Table({
                width: { size: 106, type: WidthType.PERCENTAGE },
                alignment: AlignmentType.LEFT,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },

                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Vulnerability",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,
                                        // indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Description",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.JUSTIFIED,
                                    indent: { left: 100, right: 80 },
                                    children: [new TextRun({
                                        text: vulnerability.description,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "OWASP Category ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true.valueOf,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.OWASP,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected URL Address ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 50, after: 50 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,

                                        children: [
                                            new TextRun({
                                                text: url,
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                        ]
                                    })
                                ),

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk/Impact",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    indent: { left: 100, right: 80 },
                                    alignment: AlignmentType.LEFT,
                                    // indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.risk,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.exploitation,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 100, after: 100 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.cvssString,
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        italics: false
                                    })
                                    ]
                                })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            // First cell: CVSS Score/ Risk Rating header
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "CVSS Score/ Risk Rating",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            // Second cell: Risk score and severity
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: `${riskScore} / ${severity}`,
                                                font: "Calibri",
                                                size: 22,
                                                color: color,
                                                italics: false,
                                                bold: true
                                            })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            })
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation/ Solution",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                spacing: { before: 50, after: 50 },

                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is recommended to:",
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            indent: { left: 700, right: 80 },
                                            spacing: { before: 100, after: 100 },
                                            bullet: { level: 0 },
                                            children: [
                                                new TextRun({
                                                    text: bulletText.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "000000",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    )

                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "003366" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100, right: 80 },
                                        children: [new TextRun({
                                            text: "",
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],

                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({
                spacing: { after: 200 },
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Calibri",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);

    let clientImageRun;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            clientImageRun = new ImageRun({
                data: clientImageData,
                transformation: { width: 100, height: 25 }
            })
            console.log("Selected", clientImageRun);
        }
        catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            clientImageRun = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 100, height: 25 }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }
    let FrontPageClientLogo;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            FrontPageClientLogo = new ImageRun({
                transformation: { width: 220, height: 140 },
                data: clientImageData,
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            })
            console.log("Selected", FrontPageClientLogo);
        } catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            FrontPageClientLogo = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 220, height: 140 },
                floating: {
                    zIndex: 10,
                    horizontalPosition: { offset: 2090000 },
                    verticalPosition: { offset: 2500000 },
                }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }
    // const page61 = new Paragraph({
    //     alignment: AlignmentType.LEFT,
    //     spacing: { before: 150, after: 250, },
    //     indent: { left: 400 },
    //     numbering: { reference: "my-crazy-numbering", level: 0 },
    //     tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    //     children: [
    //         new TextRun({
    //             text: "Application Overview",
    //             size: 26,
    //             color: "C00000",
    //             font: "Cambria",
    //             bold: true,
    //             italics: false,
    //             allCaps: false
    //         })
    //     ],
    //     heading: HeadingLevel.HEADING_1,
    // })

    // const page62 = new Paragraph({
    //     alignment: AlignmentType.LEFT,
    //     spacing: { before: 150, after: 250, },
    //     indent: { left: 400 },
    //     numbering: { reference: "my-crazy-numbering", level: 0 },
    //     tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    //     children: [
    //         new TextRun({
    //             text: "Objectives and Scope",
    //             size: 26,
    //             color: "C00000",
    //             font: "Cambria",
    //             bold: true,
    //             italics: false,
    //             allCaps: false
    //         })
    //     ],
    //     heading: HeadingLevel.HEADING_1,
    // })

    const doc = new Document({
        creator: "ISECURION",
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "%1.",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 26,
                                    bold: true,
                                    color: "c00000",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "9.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "#0f0f3f", bold: true, size: 24, font: "Calibri" },
                                run: {
                                    size: 26,
                                    bold: true,
                                    color: "c00000",
                                    font: "Cambria"
                                },
                            },
                        },
                        {
                            level: 2,
                            format: LevelFormat.DECIMAL,
                            text: "11.%3",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "0f0f3f",
                                    font: "Calibri"
                                },
                            },
                        },

                    ]
                }
            ]
        }, features: { updateFields: true },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Calibri",
                        bold: false,
                        size: 22,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading2: {
                    run: {
                        size: 26,
                        color: "C00000",
                        font: "Cambria",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading3: {
                    run: {
                        font: "Cambria",
                        size: 24,
                        bold: true,
                        color: "0f0f3f",
                        italics: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },

            },
        },
        sections: [
            {
                properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                children: [frontPage1, frontPage2, frontPage3, FrontPage4,
                    new Paragraph({
                        children: [FrontPageClientLogo]
                    })
                ]
            },

            {
                properties: {
                    page: {
                        margin: { header: 350, footer: 700 },
                        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                        type: SectionType.CONTINUOUS,
                    },
                },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                margin: { top: 400 },
                                width: { size: 110, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.LEFT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.LEFT, children: [footerIsecurion] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 50, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [

                                            new TableCell({
                                                width: { size: 65, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Confidential 2026",
                                                                font: "Calibri",
                                                                size: 22,
                                                                italics: false,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 32, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 3, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 22,
                                                                bold: true,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                },

                children: [page11c, page12c, page13c, page14c],
                pageBreakBefore: true,

            },
            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page11, page12, page13, page14],
                pageBreakBefore: true
            },
            {
                properties: { ...design },
                children: [page21, page22, page23, page24],
                pageBreakBefore: true
            },
            //---------------------- page 2 End----------------------
            //---------------------- page 3 Start----------------------

            {
                properties: { ...design },
                children: [page31,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        // indent: { size: 500, type: WidthType.DXA },
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 100, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),],

                pageBreakBefore: true
            },
            //---------------------- page 3 End----------------------
            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [AboutHeading, page42, page43, page44, page45, page46, page47, page48, page49, page50, page51],
                pageBreakBefore: true
            },
            //---------------------- page 4 End----------------------

            // //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [DisclaimerHeading, page52, page53, page54, page55, page56],
                pageBreakBefore: true
            },
            // //---------------------- page 5 End----------------------
            // //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [ApploicationOveriew, page62, Objectives, page64, page65, page66, page67, page68, page69, page70
                ],
                pageBreakBefore: true
            },
            // ---------------------- page 6 End----------------------
            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [Executive, page72, page73, page74, new Paragraph({
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    spacing: { line: 276, before: 250, after: 300 },
                    alignment: AlignmentType.JUSTIFIED,
                    children: [
                        new TextRun({
                            text: `Testing was performed on the ${environmentType} Environment. ${testingType} ${testingType === "Black box testing methodology (Unauthenticated Testing)"
                                    ? "was performed."
                                    : "was performed with below-mentioned user role:"
                                }`,
                            size: 22,
                            font: "Calibri",
                            color: '000000',
                            italics: false
                        }),
                    ],
                }), page76, pagee77, page78, page79],
                pageBreakBefore: true
            },

            // //---------------------- page 7 End----------------------
            // //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [Methodology, page82, page83, page84, page85, page86, page87, page88, page89],
                pageBreakBefore: true
            },
            // //---------------------- page 8 End----------------------
            // //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [page91, page92, page93, page94, page95, page96],
                pageBreakBefore: true
            },
            // //---------------------- page 9 End----------------------
            // //---------------------- page 10 Start----------------------
            {
                properties: { ...design },
                children: [Frameworkandtools, page102, page103, page104, page105, page106, page107, page108, page109, page110, page1011, page1012, page1013, page1014],
                pageBreakBefore: true
            },
            // //---------------------- page 10 End----------------------

            // //---------------------- page 11 Start----------------------
            {
                properties: { ...design },
                children: [BenchmarkingwithOWASP1, page112, page113, page114],
                pageBreakBefore: true
            },
            // //---------------------- page 11 End----------------------

            // //---------------------- page 12 Start----------------------
            {
                properties: { ...design },
                children: [page121, page122],
                pageBreakBefore: true
            },
            // //---------------------- page 12 End----------------------

            // //---------------------- page 13 Start----------------------
            {
                properties: { ...design },
                children: [ObservationSummary, page132, page133, cvssMapping, page134],
                pageBreakBefore: true
            },
            // ,
            //---------------------- page 13 End----------------------
            //---------------------- page 14 Start----------------------
            {
                properties: { ...design },
                children: [page141, page142, easeOfExploitation, page143],
                pageBreakBefore: true
            },
            // //---------------------- page 14 End----------------------

            // //---------------------- page 15 Start----------------------
            {
                properties: { ...design },
                children: [page151, page152, page153, page154],
                pageBreakBefore: true
            },
            // //---------------------- page 15 End----------------------

            // //---------------------- page 16 Start----------------------
            {
                properties: { ...design },
                children: [page161, page162,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        spacing: { before: 1200 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        },
                        rows: rows
                    })],
                pageBreakBefore: true
            },
            // //---------------------- page 16 End----------------------

            // //---------------------- page 17 Start----------------------
            {
                properties: { ...design },
                children: [page171, page172, page173, page174],
                pageBreakBefore: true
            },
            // //---------------------- page 17 End----------------------

            // //---------------------- page 18 Start----------------------
            {
                properties: { ...design },
                children: [
                    ...docSectionsResolved.flat()
                ],
                pageBreakBefore: true

            },
            // //---------------------- page 18 End----------------------


            // //---------------------- page 19 Start----------------------
            {
                properties: { ...design },
                children: [MethodsHeading, page191],
                pageBreakBefore: true
            },

            // //---------------------- page 19 End----------------------

            // //----------------------Conclusion page Start ----------------------
            {
                properties: { ...design },
                children: [Conclusion, page201, page202, page203, page204, page205, page206, page207, page208, page209, page210, page211]
            }
            // //----------------------  Conclusion page End----------------------





        ]

    })


    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }
}